export const HAIRSP = ' ';
export const NBSP = ' ';
